/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FontObjectV1Dto } from './FontObjectV1Dto';
export type FieldTextV1Dto = {
  /**
   * UUID of the document the field belongs to
   */
  document_id: string;
  /**
   * Height of the field in pixels
   */
  height?: number;
  /**
   * ID of the field
   */
  id: string;
  /**
   * Name of the field
   */
  name?: string | null;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * UUID of the signer the field is assigned to
   */
  signer_id: string;
  /**
   * Type of the field
   */
  type: FieldTextV1Dto.type;
  /**
   * Width of the field in pixels
   */
  width?: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * Answer field value
   */
  answer: string | null;
  /**
   * Default value for the text field
   */
  default_value: string | null;
  /**
   * Font settings for the text field
   */
  font: FontObjectV1Dto;
  /**
   * Instruction for the text field
   */
  instruction: string | null;
  /**
   * Maximum length of the text field
   */
  max_length: number;
  /**
   * Whether the field is optional
   */
  optional: boolean;
  /**
   * Question associated with the text field
   */
  question: string;
  /**
   * Whether the field is read-only
   */
  readonly: boolean;
};
export namespace FieldTextV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
